/**
 * Việc lắng nghe riêng lẻ các thay đổi của router sẽ gây lãng phí hiệu năng render. Sử dụng mô hình publish-subscribe để quản lý phân phối sự kiện.
 */
import type { Handler } from 'mitt'
import mitt from 'mitt'
import type { RouteLocationNormalized } from 'vue-router'

const emitter = mitt()

const key = Symbol('ROUTE_CHANGE')

let latestRoute: RouteLocationNormalized

export function setRouteEmitter(to: RouteLocationNormalized) {
  emitter.emit(key, to)
  latestRoute = to
}
export function listenerRouteChange(
  handler: (route: RouteLocationNormalized) => void,
  immediate = true
) {
  emitter.on(key, handler as Handler)
  if (immediate && latestRoute) handler(latestRoute)
}

export function removeRouteListener() {
  emitter.off(key)
}
